// Analytics integration points. Real IDs (GA4 / GTM / Meta / TikTok) are injected
// only when provided via environment variables. Never hard-coded.
export function initTracking() {
  const gtmId = process.env.REACT_APP_GTM_ID;
  // index.html already loads GTM unconditionally (GTM-MM3G9HMV) and sets this
  // flag; skip here so GTM can never load twice if REACT_APP_GTM_ID is set.
  if (gtmId && !window.__HYENAMIND_GTM_LOADED__) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
    document.head.appendChild(s);
    window.__HYENAMIND_GTM_LOADED__ = true;
  }
}

export function trackEvent(event, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    /* noop */
  }
}

export const EVENTS = {
  homeownerQuoteCta: 'homeowner_quote_cta_click',
  homeownerFormStart: 'homeowner_quote_form_start',
  homeownerStepComplete: 'homeowner_quote_step_complete',
  homeownerSubmit: 'homeowner_quote_submit',
  contractorLeadCta: 'contractor_lead_cta_click',
  contractorAppStart: 'contractor_application_start',
  contractorAppSubmit: 'contractor_application_submit',
  growthCta: 'growth_cta_click',
  // Growth Bottleneck assessment. assessmentSubmit fires only after the
  // backend returns a created lead, never on the button click.
  assessmentStart: 'assessment_start',
  assessmentStep: 'assessment_step_complete',
  assessmentSubmit: 'assessment_submit',
  consultationBooked: 'consultation_booked',
  phoneClick: 'phone_click',
  emailClick: 'email_click',
  growthPromptShown: 'growth_prompt_shown',
  growthPromptGoal: 'growth_prompt_goal_select',
  growthPromptContinue: 'growth_prompt_continue',
  growthPromptDismiss: 'growth_prompt_dismiss',
  profileEnquiryOpen: 'profile_enquiry_open',
  profileEnquirySubmit: 'profile_enquiry_submit',
  // /php-migration. The submit event fires only after the backend returns a
  // created lead, and carries categories only, never contact details.
  phpMigrationCta: 'php_migration_cta_click',
  phpMigrationSubmit: 'php_migration_submit',
  phpMigrationRoute: 'php_migration_route_select',
  // General contact form: fires only after the API confirms the lead (categories only).
  contactSubmit: 'contact_submit',
  // A click from an article to a service or conversion page: interest, never a lead.
  resourceServiceLink: 'resource_service_link_click',
};
